<template>
  <SectionTemplate
    class="mansory-gallery-section"
    :title="!hideTitle ? 'Galeria' : ''"
    title-align="left"
    :no-container="noContainer"
  >
    <div ref="grid" class="mansory-gallery-section_grid" :style="cssVars"></div>
  </SectionTemplate>
</template>

<script>
import SectionTemplate from "../templates/SectionTemplate.vue";
import Masonry from "masonry-layout";

export default {
  props: {
    items: {
      type: Array, // { src }[]
      default: () => [],
    },
    noContainer: {
      type: Boolean,
      default: false,
    },
    cols: {
      /**
       * {
       *   xs: [String, Number],
       *   sm: [String, Number],
       *   md: [String, Number],
       *   lg: [String, Number],
       *   xl: [String, Number],
       * }
       */
      type: Object,
      default: () => ({
        xs: 2,
        sm: 3,
        md: 4,
        lg: 4,
        xl: 4,
      }),
    },
    gap: {
      /**
       * {
       *   xs: [String, Number],
       *   sm: [String, Number],
       *   md: [String, Number],
       *   lg: [String, Number],
       *   xl: [String, Number],
       * }
       */
      type: Object,
    },
    hideTitle: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    itemWidth: 0,
  }),
  computed: {
    breakpointName() {
      return this.$vuetify.breakpoint.name;
    },
    cssVars() {
      return {
        "--item-width": `${this.itemWidth}px`,
      };
    },
    widthGalleryWidget() {
      switch (this.$vuetify.breakpoint.name) {
        case "xl":
        case "lg":
        case "md":
          return 1300;
        case "sm":
          return 960;
        default:
          return 600;
      }
    },
  },
  methods: {
    showGallery(index) {
      const items = this.items;

      window.showGalleryWidget(items, index);
    },
    defineItemWidth() {
      this.itemWidth = this.$el.clientWidth / this.cols[this.breakpointName];
    },
    initMansory() {
      this.defineItemWidth();

      const grid = this.$refs.grid;

      const mansory = new Masonry(grid, {
        itemSelector: ".mansory-gallery-section_item",
        columnWidth: this.itemWidth,
      });

      this.items.forEach(({ src }, i) => {
        const picture = document.createElement("picture");
        const img = document.createElement("img");
        const imgWidth =
          this.widthGalleryWidget / this.cols[this.breakpointName];

        img.src = src + "?resize=1&w=" + imgWidth;

        picture.className = "mansory-gallery-section_item";

        picture.addEventListener("click", () => this.showGallery(i));

        picture.appendChild(img);

        img.addEventListener("load", () => {
          grid.appendChild(picture);
          mansory.appended(picture);
        });
      });
    },
  },
  mounted() {
    this.initMansory();
  },
  beforeDestroy() {
    this.$refs.grid.innerHTML = "";
  },
  components: {
    SectionTemplate,
  },
};
</script>

<style lang="scss">
.mansory-gallery-section {
  .mansory-gallery-section_grid {
    margin: -6px 0;

    img {
      display: flex;
      width: 100%;
      object-fit: cover;
      max-width: var(--item-width);
    }

    picture {
      width: var(--item-width);
      padding: 6px 6px;
    }

    picture::after {
      content: "";
      height: 100%;
      width: 100%;
      background-color: rgba(0, 0, 0, 0);
      position: absolute;
      top: 0;
      left: 0;
      transition: 0.2s;
      cursor: pointer;
    }

    picture:hover::after {
      background-color: rgba(0, 0, 0, 0.2);
    }
  }
}
</style>
